import React, { useState, useEffect, useRef } from 'react'
import styles from './order-list.module.scss'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { ROUTES, PERMISSIONS, BILL_STATUS_ORDER, PAGE_SIZE, PAGE_SIZE_OPTIONS } from 'consts'
import { compare, formatCash, compareCustom, tableSum } from 'utils'
import { useReactToPrint } from 'react-to-print'
import delay from 'delay'
import { useTranslation } from 'react-i18next'
import logoApp from 'assets/img/logo-app.png'

//antd
import {
  Input,
  Button,
  Row,
  DatePicker,
  Table,
  Select,
  Space,
  Tag,
  Modal,
  Popconfirm,
  notification,
  Col,
  Checkbox,
  Form,
} from 'antd'

//icons
import { PlusCircleOutlined, SearchOutlined, ToTopOutlined } from '@ant-design/icons'

//components
import PrintOrder from 'components/print/print-order'
import FilterDate from 'components/filter-date'
import ExportCSV from 'components/ExportCSV/export'
import FilterRegion from 'components/filter-region'

//apis
import { apiAllOrder, updateOrder } from 'apis/order'
import { getEnumOrderStatus, getEnumShipStatus } from 'apis/enum'

const INIT_RATING_SERVICE = [
  {
    name: 'Service',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Staff',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Food quality',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Food selection',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Drink quality',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Drink selection',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Coffee flavor',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
  {
    name: 'Overall',
    ratings: [
      { ratting: 'Poor', checked: false },
      { ratting: 'Below Average', checked: false },
      { ratting: 'Average', checked: false },
      { ratting: 'Above Average', checked: false },
      { ratting: 'Excellent', checked: false },
    ],
  },
]
export default function OrderList() {
  const { t } = useTranslation()
  let printOrderRef = useRef()
  const history = useHistory()
  const typingTimeoutRef = useRef(null)
  const handlePrint = useReactToPrint({
    content: () => printOrderRef.current,
  })

  const [dataPrint, setDataPrint] = useState(null)

  const [loading, setLoading] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([])
  const [orders, setOrders] = useState([])
  const [countOrder, setCountOrder] = useState(0)
  const [enumPaymentStatus, setEnumPaymentStatus] = useState([])
  const [enumShipStatus, setEnumShipStatus] = useState([])

  const [paramsFilter, setParamsFilter] = useState({ page: 1, page_size: PAGE_SIZE })
  const [valueSearch, setValueSearch] = useState('')

  const Print = () => (
    <div style={{ display: 'none' }}>
      <PrintOrder ref={printOrderRef} data={dataPrint} />
    </div>
  )

  const _getEnumPaymentStatus = async () => {
    try {
      const res = await getEnumOrderStatus()
      if (res.status === 200) setEnumPaymentStatus(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _getEnumOrderShippingStatus = async () => {
    try {
      const res = await getEnumShipStatus()
      if (res.status === 200) setEnumShipStatus(res.data.data)
    } catch (e) {
      console.log(e)
    }
  }

  const _updateOrder = async (body, id) => {
    try {
      setLoading(true)
      const res = await updateOrder(body, id)
      setLoading(false)
      if (res.status === 200) {
        if (res.data.success) {
          _getOrders()
          notification.success({ message: 'Cập nhật đơn hàng thành công' })
        } else
          notification.error({
            message: res.data.message || 'Cập nhật đơn hàng thất bại, vui lòng thử lại',
          })
      } else
        notification.error({
          message: res.data.message || 'Cập nhật đơn hàng thất bại, vui lòng thử lại',
        })
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const _onSearch = (e) => {
    const value = e.target.value
    setValueSearch(value)
    if (typingTimeoutRef.current) {
      clearTimeout(typingTimeoutRef.current)
    }
    typingTimeoutRef.current = setTimeout(() => {
      paramsFilter.page = 1

      if (value) paramsFilter.order_id = value
      else delete paramsFilter.order_id

      setParamsFilter({ ...paramsFilter })
    }, 650)
  }

  const _onChangeDate = (date, dateString) => {
    paramsFilter.page = 1

    if (date) {
      paramsFilter.from_date = dateString[0]
      paramsFilter.to_date = dateString[1]
    } else {
      delete paramsFilter.from_datef
      delete paramsFilter.to_date
    }

    setParamsFilter({ ...paramsFilter })
  }

  const _onChangeStatusPayment = (value) => {
    if (value == 1 || value == 0) paramsFilter.is_paid = value
    else delete paramsFilter.is_paid

    setParamsFilter({ ...paramsFilter })
  }

  const _onChangeStatusShipping = (value) => {
    if (value) paramsFilter.shipping_status = value
    else delete paramsFilter.shipping_status

    setParamsFilter({ ...paramsFilter })
  }

  const _onChangeBill = (value) => {
    paramsFilter.page = 1

    if (value !== undefined) paramsFilter.has_invoice = value
    else delete paramsFilter.has_invoice

    setParamsFilter({ ...paramsFilter })
  }

  const _onChangeComment = (value) => {
    paramsFilter.page = 1

    if (value !== undefined) paramsFilter.is_comment = value
    else delete paramsFilter.is_comment

    setParamsFilter({ ...paramsFilter })
  }

  const ModalComment = ({ children, record }) => {
    const [formComment] = Form.useForm()

    const [ratings, setRatings] = useState(INIT_RATING_SERVICE)

    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)

    useEffect(() => {
      if (!visible) {
        formComment.resetFields()
        setRatings([...INIT_RATING_SERVICE])
      } else {
        if (record && record.is_comment) {
          formComment.setFieldsValue({ ...record.comment_info })
          setRatings([...record.comment_info.ratings])
        }
      }
    }, [visible])

    return (
      <>
        <div onClick={toggle}>{children}</div>
        <Modal
          style={{ top: 20 }}
          bodyStyle={{ padding: 0 }}
          width={600}
          closable={false}
          visible={visible}
          onCancel={toggle}
          footer={null}
        >
          <div>
            <Row justify="center">
              <img src={logoApp} alt="logo app" style={{ width: 120, marginTop: 15 }} />
            </Row>
            <div style={{ backgroundColor: 'red', height: 11, marginTop: 14 }}></div>
            <div style={{ padding: 20, fontSize: 15 }}>
              <div>
                <div>!Hóla!</div>
                <div>How much did you like us?</div>
              </div>
              <br />
              <div style={{ fontSize: 14, lineHeight: 1 }}>
                <Row wrap={false} style={{ textAlign: 'center' }}>
                  <Col span={5}></Col>
                  <Col span={4}>
                    <Row justify="center">Poor</Row>
                  </Col>
                  <Col span={4}>
                    <Row justify="center">Below Average</Row>
                  </Col>
                  <Col span={4}>
                    <Row justify="center">Average</Row>
                  </Col>
                  <Col span={4}>
                    <Row justify="center">Above Average</Row>
                  </Col>
                  <Col span={4}>
                    <Row justify="center">Excellent</Row>
                  </Col>
                </Row>
                {ratings.map((item, index) => (
                  <Row wrap={false} style={{ marginTop: 15 }}>
                    <Col span={5}>{item.name}</Col>
                    {item.ratings.map((r, indexRatting) => (
                      <Col span={4}>
                        <Row justify="center">
                          <Checkbox
                            style={{ pointerEvents: record && record.is_comment && 'none' }}
                            checked={r.checked}
                            onChange={(e) => {
                              const ratingsNew = [...ratings]
                              ratingsNew[index].ratings[indexRatting].checked = e.target.checked
                              setRatings([...ratingsNew])
                            }}
                          />
                        </Row>
                      </Col>
                    ))}
                  </Row>
                ))}
                <br />
                <Form form={formComment} layout="vertical">
                  <div>
                    <Form.Item initialValue="" label="Name:" name="name">
                      <Input.TextArea
                        style={{ pointerEvents: record && record.is_comment && 'none' }}
                        rows={1}
                      />
                    </Form.Item>
                    <Form.Item initialValue="" label="Phone:" name="phone">
                      <Input.TextArea
                        style={{ pointerEvents: record && record.is_comment && 'none' }}
                        rows={1}
                      />
                    </Form.Item>
                    <Form.Item initialValue="" label="Comment:" name="content">
                      <Input.TextArea
                        style={{ pointerEvents: record && record.is_comment && 'none' }}
                        rows={3}
                      />
                    </Form.Item>
                    <Form.Item
                      initialValue=""
                      label="Email (to join our mailing list):"
                      name="email"
                    >
                      <Input.TextArea
                        style={{ pointerEvents: record && record.is_comment && 'none' }}
                        rows={2}
                      />
                    </Form.Item>
                    <Form.Item
                      initialValue={moment(new Date()).format('DD/MM/YYYY')}
                      label="Date (optional):"
                      name="date_comment"
                    >
                      <Input.TextArea
                        style={{ pointerEvents: record && record.is_comment && 'none' }}
                        rows={1}
                      />
                    </Form.Item>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </Modal>
      </>
    )
  }

  const ModalInfoInvoice = ({ record, children }) => {
    const [visible, setVisible] = useState(false)
    const toggle = () => setVisible(!visible)

    return (
      <>
        <a onClick={toggle}>{children}</a>
        <Modal
          width="50%"
          title={`Thông tin xuất hóa đơn của đơn hàng #${record.code}`}
          footer={null}
          visible={visible}
          onCancel={toggle}
        >
          <div style={{ fontWeight: 600, fontSize: 16 }}>
            <div>Company/Customer Name: {record.invoice_info.company_name}</div>
            <div>Tax code: {record.invoice_info.tax_code}</div>
            <div>Email: {record.invoice_info.email}</div>
            <div>Address: {record.invoice_info.address}</div>
            <div>Phone: {record.invoice_info.phone}</div>
          </div>
        </Modal>
      </>
    )
  }

  const columnsOrder = [
    {
      title: t('order_list.order_code'),
      dataIndex: 'code',
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: t('common.create_date'),
      dataIndex: 'create_date',
      render: (text, record) => text && moment(text).format('DD/MM/YYYY HH:mm'),
      sorter: (a, b) => moment(a.create_date).unix() - moment(b.create_date).unix(),
    },
    {
      title: 'Thời gian hẹn giao',
      dataIndex: 'raw_complete_time',
      render: (text, record) => record.shipping_info && record.shipping_info.raw_complete_time,
    },
    {
      title: t('order_list.customer_info'),
      // sorter: (a, b) =>
      //   compareCustom(
      //     a.customer ? `${a.customer.first_name} ${a.customer.last_name}` : '',
      //     b.customer ? `${b.customer.first_name} ${b.customer.last_name}` : ''
      //   ),
      render: (text, record) =>
        record.shipping_info.to_name +
          ' - ' +
          record.shipping_info.to_phone +
          ' - ' +
          record.shipping_info.to_address || '',
    },
    // {
    //   title: t('order_list.employee'),
    //   sorter: (a, b) =>
    //     compareCustom(
    //       a.employee ? `${a.employee.first_name} ${a.employee.last_name}` : '',
    //       a.employee ? `${b.employee.first_name} ${b.employee.last_name}` : ''
    //     ),

    //   render: (text, record) =>
    //     record.employee ? `${record.employee.first_name} ${record.employee.last_name}` : '',
    // },

    // {
    //   title: 'Xuất HĐ',
    //   width: 60,
    //   render: (text, record) =>
    //     record.invoice_info &&
    //     record.invoice_info.company_name && (

    //     ),
    // },
    {
      title: 'Chi nhánh nhận giao',
      render: (text, record) => record.branch_info && record.branch_info.name,
    },
    {
      title: 'Nhân viên giao hàng',
      render: (text, record) => record.shipper_info && record.shipper_info.full_name,
    },
    {
      title: 'Trạng thái đơn',
      render: (text, record) => (
        <Tag color={record.bill_status === 'COMPLETE' ? 'success' : 'processing'}>
          {record.bill_status === 'COMPLETE' ? 'Đã thanh toán' : 'Đợi thanh toán'}
        </Tag>
      ),
      sorter: (a, b) => compare(a, b, 'bill_status'),
    },
    {
      title: 'Giao hàng',
      render: (text, record) => {
        var txt = 'Đợi giao'
        if (record.shipping_status === 'SHIPPED') txt = 'Đã giao'

        if (record.shipping_status === 'SHIPPING') txt = 'Đang giao'
        return (
          <Tag color={record.shipping_status === 'SHIPPED' ? 'success' : 'processing'}>{txt}</Tag>
        )
      },
      sorter: (a, b) => compare(a, b, 'bill_status'),
    },
    {
      title: 'Cổng thanh toán',
      render: (text, record) => record.payment_infos.map((info) => info.name),
      sorter: (a, b) => compare(a, b, 'payment_status'),
    },
    {
      title: 'TT Thanh toán',
      render: (text, record) =>
        record.is_paid == 1 ? (
          <Tag color={'success'}>{'Đã thanh toán'}</Tag>
        ) : (
          <Tag color={'processing'}>{'Chưa thanh toán'}</Tag>
        ),
      sorter: (a, b) => compare(a, b, 'payment_status'),
    },
    {
      title: t('order_list.guest_must_pay'),
      dataIndex: 'final_cost',
      sorter: (a, b) => compare(a, b, 'final_cost'),
      render: (text) => formatCash(text),
    },
    {
      title: 'Nhận xét',
      render: (text, record) =>
        record.is_comment && (
          <ModalComment record={record}>
            <a>Xem nhận xét</a>
          </ModalComment>
        ),
    },
    {
      title: 'Hành động',
      render: (text, record) => {
        return (
          <div>
            {record.invoice_info && record.invoice_info.company_name && !record.is_export_invoice && (
              <Popconfirm
                onConfirm={() => _updateOrder({ is_export_invoice: true }, record.order_id)}
                title="Bạn có muốn xuất hóa đơn cho đơn hàng này không?"
              >
                <Button type="primary">Xuất hóa đơn</Button>
              </Popconfirm>
            )}

            {record.bill_status == 'DRAFT' && (
              <Popconfirm
                onConfirm={() => _updateOrder({ bill_status: 'COMPLETE' }, record.order_id)}
                title="Xác nhận khách đã thanh toán (đã nhận đủ tiền) ?"
              >
                <Button style={{ marginTop: 10 }} type="primary">
                  Xác nhận thanh toán
                </Button>
              </Popconfirm>
            )}
          </div>
        )
      },
    },
  ]

  const columnsProduct = [
    {
      title: t('order_list.food_code'),
      dataIndex: 'code',
      render: (text, record) => (record.product_info ? record.product_info.code : ''),
      sorter: (a, b) => compare(a, b, 'code'),
    },
    {
      title: t('common.image'),
      dataIndex: 'image',
      render: (text, record) =>
        record.product_info ? (
          <img
            src={record.product_info.image_urls && record.product_info.image_urls[0]}
            style={{ maxWidth: 60, maxHeight: 60 }}
            alt=""
          />
        ) : (
          ''
        ),
    },
    {
      title: t('order_list.food_name'),
      dataIndex: 'name',
      render: (text, record) => (record.product_info ? record.product_info.name : ''),
      sorter: (a, b) => compare(a, b, 'name'),
    },
    {
      title: t('order_list.quantity'),
      dataIndex: 'quantity',
      sorter: (a, b) => compare(a, b, 'quantity'),
    },
    {
      title: t('order_list.unit_price'),
      sorter: (a, b) => compare(a, b, 'price'),

      render: (text, record) => (record.price ? formatCash(+record.price) : 0),
    },
    {
      title: t('order_list.discount'),
      sorter: (a, b) => compare(a, b, 'discount'),

      render: (text, record) => (record.discount ? formatCash(+record.discount) : 0),
    },
    {
      title: t('order_list.note'),
      sorter: (a, b) => compare(a, b, 'note'),

      render: (text, record) => record.note,
    },
    {
      title: t('order_list.into_money'),
      sorter: (a, b) => compare(a, b, 'total_cost'),
      render: (text, record) => (record.total_cost ? formatCash(+record.total_cost) : 0),
    },
  ]

  const _getOrders = async () => {
    try {
      setLoading(true)
      const res = await apiAllOrder(paramsFilter)
      if (res.status === 200) {
        setOrders(res.data.data)
        setCountOrder(res.data.count)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }

  const _getOrdersToExport = async () => {
    let dataExport = []
    try {
      setLoading(true)
      const res = await apiAllOrder()
      if (res.status === 200) {
        dataExport = res.data.data.map((item, index) => ({
          STT: index + 1,
          'Mã đơn hàng': item.code || '',
          'Ngày tạo': item.create_date ? moment(item.create_date).format('DD-MM-YYYY HH:mm') : '',
          'Thông tin người nhận':
            item.shipping_info.to_name +
              ' - ' +
              item.shipping_info.to_phone +
              ' - ' +
              item.shipping_info.to_address || '',
          'Trạng thái': item.bill_status,
          'Cổng thanh toán': item.payment_infos[0]?.name,
          'Khách phải trả': item.final_cost,
        }))
      }
      setLoading(false)
      ExportCSV(dataExport, 'Danh sách món ăn')
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  useEffect(() => {
    _getOrders()
  }, [paramsFilter])

  useEffect(() => {
    _getEnumPaymentStatus()
    _getEnumOrderShippingStatus()
  }, [])

  return (
    <>
      <Print />
      <div className={`${styles['promotion_manager']} ${styles['card']}`}>
        <Row
          justify="space-between"
          wrap={false}
          align="middle"
          style={{
            borderBottom: '1px solid rgb(236, 226, 226)',
            paddingBottom: '0.75rem',
            width: '100%',
          }}
        >
          <h3 style={{ marginBottom: 0, fontSize: 19 }}>{t('layout.order_list')}</h3>
          <Button onClick={_getOrdersToExport} size="large" type="primary" icon={<ToTopOutlined />}>
            Xuất Excel
          </Button>
          {/* <Permissions permissions={[PERMISSIONS.tao_don_hang]}>
            <Button
              onClick={() => history.push(ROUTES.ORDER_CREATE)}
              size="large"
              type="primary"
              icon={<PlusCircleOutlined />}
            >
              Tạo đơn hàng
            </Button>
          </Permissions> */}
        </Row>

        <Row style={{ marginTop: '1rem', width: '100%' }} wrap={false}>
          <Space>
            <div>
              {/* <div>{t('order_list.search_by_order_code')}</div> */}
              <Input
                style={{ width: 300 }}
                prefix={<SearchOutlined />}
                size="large"
                name="name"
                value={valueSearch}
                onChange={_onSearch}
                placeholder={t('order_list.enter_order_code')}
                allowClear
              />
            </div>
            <div>
              {/* <div>{t('common.filter_by_time')}</div> */}
              {/* <RangePicker
                onChange={_onChangeDate}
                style={{ width: 270 }}
                size="large"
                className="br-15__date-picker"
                ranges={{
                  Today: [moment(), moment()],
                  'This Month': [moment().startOf('month'), moment().endOf('month')],
                }}
              /> */}
              <FilterDate
                size="large"
                width={270}
                paramsFilter={paramsFilter}
                setParamsFilter={setParamsFilter}
              />
            </div>
            <div>
              {/* <div>{t('order_list.filter_by_status')}</div> */}
              <Select
                value={paramsFilter.value}
                onChange={_onChangeStatusPayment}
                showSearch
                size="large"
                allowClear
                placeholder={'Trạng thái thanh toán'}
                style={{ width: 250 }}
              >
                {enumPaymentStatus.map((status, index) => (
                  <Select.Option value={status.name} key={index}>
                    {status.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
            <div>
              <Select
                value={paramsFilter.value}
                onChange={_onChangeStatusShipping}
                showSearch
                size="large"
                allowClear
                placeholder={'Trạng thái giao hàng'}
                style={{ width: 250 }}
              >
                {enumShipStatus.map((status, index) => (
                  <Select.Option value={status.name} key={index}>
                    {status.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </Space>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Space>
            <div>
              {/* <div>Lọc theo quốc gia/ khu vực/ chi nhánh</div> */}
              <FilterRegion
                width_size={300}
                setParamsFilter={setParamsFilter}
                paramsFilter={paramsFilter}
              />
            </div>
            <div>
              {/* <div>Lọc theo yêu cầu xuất hóa đơn</div> */}
              <Select
                value={paramsFilter.has_invoice}
                onChange={_onChangeBill}
                showSearch
                size="large"
                allowClear
                placeholder="Chọn yêu cầu xuất hóa đơn"
                style={{ width: 270 }}
              >
                <Select.Option value={true}>Yêu cầu xuất hóa đơn</Select.Option>
                <Select.Option value={false}>Không yêu cầu xuất hóa đơn</Select.Option>
              </Select>
            </div>
            <div>
              <Select
                value={paramsFilter.is_comment}
                onChange={_onChangeComment}
                showSearch
                size="large"
                allowClear
                placeholder="Lọc theo hàng có nhận xét"
                style={{ width: 250 }}
              >
                <Select.Option value={true}>Có nhận xét</Select.Option>
                <Select.Option value={false}>Không có nhận xét</Select.Option>
              </Select>
            </div>
          </Space>
        </Row>

        <Table
          size="small"
          rowKey="_id"
          loading={loading}
          // rowSelection={{
          //   selectedRowKeys,
          //   onChange: (keys) => setSelectedRowKeys(keys),
          // }}
          expandable={{
            expandedRowRender: (record) => {
              return (
                <div style={{ padding: '17px 10px' }}>
                  <Row wrap={false}>
                    <div
                      style={{
                        width: 'calc(100% - 165px)',
                        backgroundColor: '#FFFFFF',
                        borderRadius: 5,
                        border: '1px solid #E8EAEB',
                        padding: '15px 0px',
                        marginRight: 15,
                        fontSize: 14.7,
                      }}
                    >
                      <Row wrap={false}>
                        <div style={{ width: '33.33333%', padding: '0px 25px' }}>
                          <p style={{ fontWeight: 700, marginBottom: 6 }}>
                            {t('order_list.order_infomation')}
                          </p>
                          <Row justify="space-between">
                            <div style={{ color: '#747C87' }}>{t('order_list.order_code')}:</div>
                            <div>{record.order_id || ''}</div>
                          </Row>
                          <Row justify="space-between">
                            <div style={{ color: '#747C87' }}>{t('common.create_date')}:</div>
                            <div>{moment(record.create_date).format('YYYY-MM-DD HH:mm')}</div>
                          </Row>
                          <Row justify="space-between">
                            <div style={{ color: '#747C87' }}>{'Khách hẹn giao '}:</div>
                            <div>
                              {record.shipping_info ? record.shipping_info.raw_complete_time : ''}
                            </div>
                          </Row>

                          <Row justify="space-between">
                            <div style={{ color: '#747C87' }}>{'Thời điểm thanh toán '}:</div>
                            <div>
                              {record.shipping_info
                                ? moment(record.shipping_info.payment_time).format(
                                    'YYYY-MM-DD HH:mm'
                                  )
                                : ''}
                            </div>
                          </Row>
                          {/* <Row justify="space-between">
                            <div style={{ color: '#747C87' }}>{t('order_list.sales_source')}:</div>
                            <div>POS</div>
                          </Row> */}
                          {/* <Row justify="space-between">
                            <div style={{ color: '#747C87' }}>{t('order_list.salesman')}:</div>
                            <div>
                              {record.employee
                                ? `${record.employee.first_name} ${record.employee.last_name}`
                                : ''}
                            </div>
                          </Row> */}
                        </div>
                        <ModalInfoInvoice record={record}>
                          {record.is_export_invoice ? (
                            <Tag color="success">Đã xuất hóa đơn (xem chi tiết)</Tag>
                          ) : (
                            <Tag color="error">Chưa xuất hóa đơn (xem chi tiết)</Tag>
                          )}
                        </ModalInfoInvoice>
                        <div
                          style={{
                            width: '33.33333%',
                            padding: '0px 25px',
                            borderRight: '1px solid #E8EAEB',
                          }}
                        >
                          <p style={{ fontWeight: 700, marginBottom: 6 }}>
                            {t('order_list.receiver')}
                          </p>
                          <Row wrap={false} style={{ width: '100%' }}>
                            <a>{record.shipping_info.to_name + ' - '}</a>
                            <div style={{ marginLeft: 3 }}>
                              {record.shipping_info.to_phone || ''}
                            </div>
                          </Row>
                          <div>{record.shipping_info.to_address || ''}</div>

                          <p style={{ fontWeight: 700, marginBottom: 6 }}>
                            {'Shipper giao hàng: '}
                          </p>
                          {record.shipper_info && (
                            <Row wrap={false} style={{ width: '100%' }}>
                              <a>{record.shipper_info.full_name + ' - '}</a>
                              <div style={{ marginLeft: 3 }}>{record.shipper_info.phone || ''}</div>
                            </Row>
                          )}
                        </div>
                        <div style={{ width: '33.33333%', padding: '0px 25px' }}>
                          <div style={{ marginBottom: 10 }}>
                            <p style={{ fontWeight: 700, marginBottom: 4 }}>
                              {t('order_list.order_note')}
                            </p>
                            <div style={{ color: record.note ? '' : '#747C87' }}>
                              {record.note ? record.note : t('order_list.orders_without_notes')}
                            </div>
                          </div>
                          {/* <div>
                            <p style={{ fontWeight: 700, marginBottom: 4 }}>
                              {t('order_list.tags')}
                            </p>
                            <div
                              style={{
                                color: !record.tags || !record.tags.length ? '#747C87' : '',
                              }}
                            >
                              {record.tags && record.tags.length
                                ? record.tags.join(',')
                                : t('order_list.orders_without_tags')}
                            </div>
                          </div> */}
                        </div>
                      </Row>
                    </div>
                    {/* <Space direction="vertical">
                      <Button
                        style={{ width: 140 }}
                        size="large"
                        type="primary"
                        onClick={async () => {
                          console.log(record)
                          setDataPrint({
                            ...record,
                            isDelivery: record.shipping_info ? true : false,
                            deliveryCharges:
                              record.shipping_info && (record.shipping_info.cod || 0),
                            sumCostPaid: record.total_cost,
                            discount:
                              record.promotion && Object.keys(record.promotion).length
                                ? record.promotion
                                : null,
                            moneyToBePaidByCustomer: record.final_cost,
                            deliveryAddress: record.shipping_info,
                            moneyGivenByCustomer: 0,
                            prepay: 0,
                          })
                          await delay(500)
                          handlePrint()
                        }}
                      >
                        {t('order_list.order_printing')}
                      </Button>
                    </Space> */}
                  </Row>
                  <div className="table-product-in-order">
                    <Table
                      pagination={false}
                      size="small"
                      style={{ width: '99%', marginTop: 30 }}
                      columns={columnsProduct}
                      dataSource={record.order_details}
                      summary={() => (
                        <Table.Summary.Row>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell></Table.Summary.Cell>
                          <Table.Summary.Cell colSpan={2}>
                            <div style={{ fontSize: 14.7 }}>
                              <Row wrap={false} justify="space-between">
                                <div>
                                  {t('order_list.total_cost')} ({record.order_details.length}{' '}
                                  {t('order_list.dish')})
                                </div>
                                <div>{record.total_cost ? formatCash(+record.total_cost) : 0}</div>
                              </Row>
                              <Row wrap={false} justify="space-between">
                                <div>{t('order_list.discount')}</div>
                                <div>
                                  {record.total_discount
                                    ? formatCash(record.total_discount || 0)
                                    : 0}
                                </div>
                              </Row>
                              <Row wrap={false} justify="space-between">
                                <div>Phí giao hàng</div>
                                <div>
                                  {record.shipping_info
                                    ? formatCash(+record.shipping_info.shipping_fee || 0)
                                    : 0}
                                </div>
                              </Row>
                              <Row wrap={false} justify="space-between">
                                <div>Phí dịch vụ</div>
                                <div>
                                  {record.total_service_fee
                                    ? formatCash(+record.total_service_fee || 0)
                                    : 0}
                                </div>
                              </Row>
                              <Row
                                wrap={false}
                                justify="space-between"
                                style={{ display: record.voucher === '' && 'none' }}
                              >
                                <div>Mã voucher</div>
                                <div>{record.voucher}</div>
                              </Row>
                              <Row wrap={false} justify="space-between">
                                <div>Danh sách thuế </div>
                                <div>
                                  {record.tax_list.map((tax) => {
                                    return (
                                      tax.name &&
                                      tax.type != 'discount' &&
                                      tax.type != 'service_fee' && (
                                        <Row>{tax.name + ' ' + tax.total_tax}</Row>
                                      )
                                    )
                                  })}
                                </div>
                              </Row>
                              <Row wrap={false} justify="space-between" style={{ fontWeight: 600 }}>
                                <div>{t('order_list.guest_must_pay')}</div>
                                <div>
                                  {record.final_cost ? formatCash(+record.final_cost || 0) : 0}
                                </div>
                              </Row>
                            </div>
                          </Table.Summary.Cell>
                        </Table.Summary.Row>
                      )}
                    />
                  </div>
                </div>
              )
            },
          }}
          columns={columnsOrder}
          style={{ width: '100%', marginTop: 35 }}
          pagination={{
            current: paramsFilter.page,
            pageSize: paramsFilter.page_size,
            pageSizeOptions: PAGE_SIZE_OPTIONS,
            showQuickJumper: true,
            onChange: (page, pageSize) => {
              paramsFilter.page = page
              paramsFilter.page_size = pageSize

              setParamsFilter({ ...paramsFilter })
            },
            total: countOrder,
          }}
          dataSource={orders}
        />
      </div>
    </>
  )
}
